import { generateDateText, IDateParts } from './partsFromDate';

const generateLabelFromDateToDateText = (
  label?: string | null,
  fromDate?: IDateParts | null,
  toDate?: IDateParts | null
) => `${label || ''} ${generateDateText(fromDate)} to ${generateDateText(toDate)}`;

export default generateLabelFromDateToDateText;
